import { createApi } from '@reduxjs/toolkit/query/react';

import { z3xBaseQuery } from 'app/utils/api.utils';

interface IUserCrdSubscriptionGet {
  crdId?: number;
}

interface IUserCrdSubscription {
  subscriptionName: string;
  expirationDate: string;
  crdId: number;
  ruleId: number;
  new: boolean;
  valid: boolean;
}

type ITransformedUserCrdSubscriptionResponse = IUserCrdSubscription[]

export const userCrdSubscriptionApi = createApi({
  reducerPath: 'userCrdSubscription',
  baseQuery: z3xBaseQuery(),
  endpoints: (builder) => ({
    getUserCrdSubscription: builder.query<ITransformedUserCrdSubscriptionResponse, IUserCrdSubscriptionGet>({
      query: ({ crdId }) => ({
        url: 'user-crd-subscriptions/' + crdId }),
    })
  }),
});

export const {
  useGetUserCrdSubscriptionQuery,
} = userCrdSubscriptionApi;